export const cart = {
  cart: "Καλάθι",
  cartItems: "Είδη Καλαθιού",
  quantity: "Ποσότητα",
  delete: "Διαγραφή",
  summary: "Περίληψη",
  productsValue: "Αξία Προϊόντων",
  total: "Σύνολο",
  numOfProducts: "Αριθμός Προϊόντων",
  yourCartIsEmpty: "Το Καλάθι σας είναι Άδειο",
  checkout: "Αγορά",
  // Checkout page translations
  contactInformation: "Στοιχεία Επικοινωνίας",
  firstName: "Όνομα",
  enterFirstName: "Εισάγετε όνομα",
  lastName: "Επώνυμο",
  enterLastName: "Εισάγετε επώνυμο",
  email: "Email",
  enterEmail: "Εισάγετε διεύθυνση email",
  phone: "Τηλέφωνο",
  enterPhone: "Εισάγετε αριθμό τηλεφώνου",
  billingInformation: "Στοιχεία Χρέωσης",
  address: "Διεύθυνση",
  enterAddress: "Εισάγετε διεύθυνση",
  city: "Πόλη",
  enterCity: "Εισάγετε πόλη",
  postalCode: "Ταχυδρομικός Κώδικας",
  enterPostalCode: "Εισάγετε ταχυδρομικό κώδικα",
  country: "Χώρα",
  enterCountry: "Εισάγετε χώρα",
  corporateInformation: "Εταιρικά Στοιχεία",
  companyName: "Όνομα Εταιρείας",
  enterCompanyName: "Εισάγετε όνομα εταιρείας",
  vatNumber: "ΑΦΜ",
  enterVatNumber: "Εισάγετε ΑΦΜ",
  paymentInformation: "Στοιχεία Πληρωμής",
  cardNumber: "Αριθμός Κάρτας",
  cardHolderName: "Όνομα Κατόχου Κάρτας",
  enterCardHolderName: "Εισάγετε όνομα κατόχου κάρτας",
  expiryDate: "Ημερομηνία Λήξης",
  cvv: "CVV",
  orderSummary: "Περίληψη Παραγγελίας",
  subtotal: "Υποσύνολο",
  shipping: "Μεταφορικά",
  proceedToPayment: "Συνέχεια στην Πληρωμή",
  backToCart: "Επιστροφή στο Καλάθι",
  paymentProcessed: "Η πληρωμή ολοκληρώθηκε επιτυχώς!",
};
